import React from 'react';
import { useUser } from '../../../hooks/shared/user/useUser';

const CreateProfilePrompt = () => {
  const { profile, load } = useUser();

  // Don't show anything while loading
  if (load) {
    return null;
  }

  // Check if user has a profile
  const hasProfile = () => {
    // If profile is an empty array, user needs to create profile
    // if (Array.isArray(profile) && profile.length === 0) {
    //   return false;
    // }

    // If profile has a message property (error response), user needs to create profile
    if (profile && profile.message === 'employee profile does not exist' && profile.status === 'failed') {
      return false;
    } else if (profile && profile.message === 'invalid signature') {
      return true;
    }
    // If profile is an object with id, user has a profile
    else if (profile && profile.id) {
      return true;
    }
    return true;
  };

  // If user has a profile, don't show the banner
  if (hasProfile()) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          border: '3px solid #26c2ba',
        }}
      >
        <div
          style={{
            backgroundColor: '#26c2ba',
            color: 'white',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '30px',
            fontWeight: 'bold',
            margin: '0 auto 20px auto',
          }}
        >
          !
        </div>

        <h2 style={{ color: '#333', marginBottom: '15px', fontSize: '24px' }}>Complete Your Profile Required</h2>

        <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6', marginBottom: '30px' }}>
          You need to complete your profile before accessing the system. Your profile ensures you have the best
          experience possible.
        </p>

        <strong
          style={{
            fontSize: '18px',
            color: 'white',
            cursor: 'pointer',
            backgroundColor: '#26c2ba',
            padding: '15px 30px',
            borderRadius: '25px',
            border: 'none',
            display: 'inline-block',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)',
          }}
          data-toggle="modal"
          data-target="#add-employee"
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#c82333';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#dc3545';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(220, 53, 69, 0.3)';
          }}
        >
          Create Your Profile Now →
        </strong>

        <div style={{ marginTop: '20px', fontSize: '12px', color: '#999' }}>This step is required to continue</div>
      </div>
    </div>
  );
};

export default CreateProfilePrompt;
